// src/services/apiService/api/retailerMappingApi.js
import { COMMON_TYPES, TEMPLATE_KEYS } from '../../../helper/commonTypes';
import { HTTP_METHOD } from '../../../helper/constants';
import request from '../../request';
import { upload, history, downloadByRequestId, downloadTemplate } from './commonActionsApi';

const TYPE = COMMON_TYPES.RETAILER_EMPLOYEE_MAPPING;

export default {
  uploadRetailerMappingData: ({ formData, action, username }) => upload({ type: TYPE, formData, action, username }),
  getRetailerMappingHistory: ({ page = 0, pageSize = 20 } = {}) => history({ type: TYPE, page, size: pageSize }),
  downloadRetailerByRequestIdExcel: (requestId) => downloadByRequestId({ requestId }),
  downloadRetailerInsertTemplate: () => downloadTemplate({ templateKey: TEMPLATE_KEYS.INSERT[TYPE] }),
  downloadRetailerDeleteTemplate: () => downloadTemplate({ templateKey: TEMPLATE_KEYS.DELETE[TYPE] }),
  downloadRetailerMappingData: (body) => {
    const url = `/retailer-employee/mapping`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  }
};